import { connect } from 'react-redux';
import DefaultAliasManagement from "./DefaultAliasManagement";
import { 
    fetchGetDefaultAlias, 
    fetchUpdateDefaultAlias, 
    getDefaultAliasData, 
    loadingAliases,
    clearDefaultAlias
} from "../../../../reducers/account/aliases";
import { 
    getCurrentContinent, 
    setCurrentContinent, 
    getCountriesData, 
    getContinentsData, 
    setCurrentContinentByCountry 
} from '../../../../reducers/common/location';
import { getTranslation } from "../../../../reducers/common/localization";
import {getCurrentRole} from "../../../../reducers/account/role";

const mapStateToProps = state => {
    return {
        loading: loadingAliases(state),
        data: getDefaultAliasData(state),
        translation: getTranslation(state),
        continentCode: getCurrentContinent(state),
        continents: getContinentsData(state),
        countries: getCountriesData(state),
        role: getCurrentRole(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onGetDefaultAlias: () => dispatch(fetchGetDefaultAlias()),
        onChangeAlias: (id, data) => {
            dispatch(fetchUpdateDefaultAlias(id, data))
        },
        onContinentSet: (continentCode) => {
            dispatch(setCurrentContinent(continentCode));
        },
        setCurrentContinentByCountry: (countryCode) => {
            dispatch(setCurrentContinentByCountry(countryCode));
        },
        onUnmount: () => {
            dispatch(clearDefaultAlias());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DefaultAliasManagement);



// WEBPACK FOOTER //
// ./src/components/accountManagement/aliasesManagement/defaultAliasManagement/DefaultAliasManagement.container.js